import { useMemo } from "react";
import { Grid, CardContent } from "@mui/material";
import { IFullFlight } from "@vmosolutions/oc-interfaces";
import { FormHeader } from "../helpers";
import { DisplayMessages } from "src/pages/FlightEditor/Messages/DisplayMessages";

interface IMessagesTabProps {
  fullFlight: IFullFlight; // Id of the flight to retrieve and edit if provided.
  updateTabState: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  setAPICallStatus: (statusMessage: string) => void;
}

/**
 * Flight Messages Tab
 * @param props -
 */
export const MessagesTab = (props: IMessagesTabProps): JSX.Element => {
  const { fullFlight, updateTabState, mosaicId, setAPICallStatus } = props;
  const { _id, departureMessages, arrivalMessages } = fullFlight ?? {};

  const subtitle = useMemo(() => {
    if (departureMessages?.length || arrivalMessages?.length) {
      return `(${arrivalMessages.length + departureMessages.length})`;
    } else {
      return "(0)";
    }
  }, [departureMessages, arrivalMessages]);

  return (
    <CardContent id={`${mosaicId}-messages-editor`} className="form_card messages">
      <Grid container direction="column">
        <FormHeader title="Movement Messages" subtitle={subtitle} />
        {fullFlight ? (
          <DisplayMessages
            windowId={mosaicId}
            departureMessages={departureMessages}
            arrivalMessages={arrivalMessages}
            // receivedDepartureMessage={receivedDepartureMessage}
            // receivedArrivalMessage={receivedArrivalMessage}
            flightId={_id}
          />
        ) : null}
      </Grid>
    </CardContent>
  );
};
